import { render, staticRenderFns } from "./ReportTabMADDs.vue?vue&type=template&id=341993d0&scoped=true"
import script from "./ReportTabMADDs.vue?vue&type=script&lang=js"
export * from "./ReportTabMADDs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341993d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('341993d0')) {
      api.createRecord('341993d0', component.options)
    } else {
      api.reload('341993d0', component.options)
    }
    module.hot.accept("./ReportTabMADDs.vue?vue&type=template&id=341993d0&scoped=true", function () {
      api.rerender('341993d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Report/Tab/ReportTabMADDs.vue"
export default component.exports